import simpleLightbox from "simplelightbox";

const slider=new simpleLightbox('.gallery a')

export {slider}